import {Vue} from 'ui.vue';



import './BXmakerAuthuserphoneSimple.styl';

import './BXmakerAuthuserphoneSimplePhone';
import './BXmakerAuthuserphoneSimpleSmsCode';
import './BXmakerAuthuserphoneSimpleUserCall';
import './BXmakerAuthuserphoneSimpleBotCall';
import './BXmakerAuthuserphoneSimpleBotSpeech';




Vue.component('BXmakerAuthuserphoneSimple', {
    name: 'BXmakerAuthuserphoneSimple',
    data() {
        return {

        };
    },
    computed: {

    },
    methods: {
        onInputPhone(value){
            this.$root.setPhone(value);
        },
        authByPhone(){
            this.$root.authByPhone();
        }
    },

    template: `
            <div class="bxmaker-authuserphone-simple" :id="'bxmaker-authuserphone-simple' + $root.rand" >
                
                  <BXmakerAuthuserphoneEmpty v-if="$root.isAuthorized" >
                 {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_IS_AUTHORIZED}} <br>
                    <a href="?logout=Y">{{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_LOGOUT}}</a>
                 </BXmakerAuthuserphoneEmpty>    
                 
               
                    <BXmakerAuthuserphoneSimplePhone 
                    v-show="!$root.isShowConfirm && !$root.isAuthorized"  
                    :loader="$root.startLoader" 
                    :phone="$root.phone" 
                    :phoneError="$root.phoneError" 
                    @onInputPhone="onInputPhone" 
                    @onClickDone="authByPhone" 
                    />   
                    
                    <BXmakerAuthuserphoneSimpleSmsCode  
                        v-show="$root.isNeedShowConfirmSmsCode"                                    
                    /> 
                    
                    <BXmakerAuthuserphoneSimpleUserCall  
                        v-show="$root.isNeedShowConfirmUserCall"   
                    /> 
                    
                    <BXmakerAuthuserphoneSimpleBotCall 
                         v-show="$root.isNeedShowConfirmBotCall"                 
                    />  
                    
                    <BXmakerAuthuserphoneSimpleBotSpeech 
                         v-show="$root.isNeedShowConfirmBotSpeech"                 
                    />  
                    
                    <div class="bxmaker-authuserphone-simple__change-confirm" v-if="$root.isNeedShowChangeConfirm"  >
                         <BXmakerAuthuserphoneLink @onClick="$root.changeConfirmType" >
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_CHANGE_CONFIRM_TYPE}}   
                         </BXmakerAuthuserphoneLink> 
                    </div>   
                
                             
            </div>
        `,
});